import React from 'react';

const LandingLogo = ({
  id = '',
  width = 48,
  height = 48,
  color = '#DCF31C',
}) => (
  <svg
    id={id}
    width={width}
    height={height}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.28903 40.7999H39.2638C45.1199 40.7999 48 37.2149 48 30.351C48 23.5905 45.2246 20.722 38.6974 20.722H33.0458C27.5977 20.722 25.2341 23.0776 25.2341 28.5073C25.2341 33.937 27.6006 36.2945 33.0458 36.2945H38.8529C39.6754 36.2945 40.0866 36.7043 40.0866 37.524C40.0866 38.3436 39.6754 38.7534 38.8529 38.7534H8.94258C8.11952 38.7534 7.70831 38.3436 7.70895 37.524C7.70959 36.7043 8.1208 36.2945 8.94258 36.2945H19.2205C21.5332 36.2945 22.5125 35.3195 22.5125 33.0147C22.5125 30.7098 21.5352 29.7368 19.2225 29.7368H8.94258C8.11952 29.7368 7.70831 29.3269 7.70895 28.5073C7.70959 27.6877 8.1208 27.2779 8.94258 27.2779H19.2205C21.5332 27.2779 22.5105 26.3048 22.5105 24C22.5105 21.6951 21.5332 20.722 19.2205 20.722H8.94258C8.11952 20.722 7.70831 20.3122 7.70895 19.4926C7.70959 18.673 8.1208 18.2631 8.94258 18.2631H16.9597C20.8142 18.2631 22.5105 16.5735 22.5105 12.732C22.5105 8.89057 20.8142 7.19995 16.9597 7.19995H3.28903C0.97634 7.19995 0 8.17299 0 10.4779C0 12.7827 0.97634 13.7558 3.28903 13.7558H13.6188C14.4412 13.7558 14.8525 14.1656 14.8525 14.9852C14.8525 15.8049 14.4412 16.2147 13.6188 16.2147H3.28903C0.97634 16.2147 0 17.1877 0 19.4926C0 21.7975 0.97634 22.7705 3.28903 22.7705H13.6188C14.4412 22.7705 14.8525 23.1803 14.8525 24C14.8525 24.8196 14.4412 25.2294 13.6188 25.2294H3.28903C0.97634 25.2294 0 26.2024 0 28.5073C0 30.8122 0.97634 31.7852 3.28903 31.7852H13.6188C14.4412 31.7852 14.8525 32.195 14.8525 33.0147C14.8525 33.8343 14.4412 34.2441 13.6188 34.2441H3.28903C0.97634 34.2441 0 35.2172 0 37.522C0 39.8269 0.97634 40.7999 3.28903 40.7999Z"
      fill={color}
    />
  </svg>
);

export default LandingLogo;
